/* Puntos de XTI Community: pulsar un punto muestra u oculta su ficha; se cierra al pulsar fuera o con Escape. */
if (!window.__wimCommunityBound) {
  window.__wimCommunityBound = true;

  const closeAll = (except) => {
    document.querySelectorAll('[data-wim-cmty-dot][aria-expanded="true"]').forEach((dot) => {
      if (dot !== except) dot.setAttribute("aria-expanded", "false");
    });
  };

  document.addEventListener("click", (event) => {
    const dot = event.target.closest("[data-wim-cmty-dot]");
    closeAll(dot);
    if (dot) dot.setAttribute("aria-expanded", String(dot.getAttribute("aria-expanded") !== "true"));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const open = document.querySelector('[data-wim-cmty-dot][aria-expanded="true"]');
    if (!open) return;
    closeAll();
    if (open.parentElement.contains(document.activeElement)) open.focus();
  });
}
